import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd";

import { sendCounterEvent } from "../../utils/counterService";

import "./WebGisSuccessModal.css";

interface Props {
  open: boolean;
  onClose: () => void;
  webgisUrl: string;
  plan: string;
}

export const WebGisSuccessModal = ({
  open,
  onClose,
  webgisUrl,
  plan,
}: Props) => {
  const { t } = useTranslation();

  const description =
    plan === "pomelo"
      ? t("webgis.successPremium")
      : plan === "mandarin"
        ? t("webgis.successMini")
        : t("webgis.successFree");

  return (
    <Modal open={open} onCancel={onClose} footer={null} width={420} centered>
      <div className="webgis-success-modal">
        <img
          src={`${import.meta.env.BASE_URL}img/webgis_started.png`}
          width={200}
          height={200}
          alt=""
        />
        <h3>{t("webgis.isReady")}</h3>
        <p className="webgis-success-modal__desc">{description}</p>
        <Button
          type="primary"
          size="large"
          block
          href={webgisUrl}
          target="_blank"
          onClick={() => sendCounterEvent("popup-go-to-webgis")}
        >
          {t("webgis.goToWebgis")}
        </Button>
        {plan !== "pomelo" && (
          <Button
            size="large"
            block
            href="/subscription"
            className="webgis-success-modal__upgrade"
            onClick={() => sendCounterEvent("popup-go-to-upgrade")}
          >
            {t("webgis.upgrade")}
          </Button>
        )}
      </div>
    </Modal>
  );
};
